import './App.css'
import 'react-toastify/dist/ReactToastify.css'
import { NavigationController } from './hoc'
import { BrowserRouter } from 'react-router-dom'
import { ThemeProvider, useTheme, useMediaQuery } from '@mui/material'
import { defaultTheme } from './styles/Theme'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { ToastContainer } from 'react-toastify'
import { ScrollToTop } from './components/ScrollToTop'
import { DesktopLayout } from './layouts/DesktopLayout'
import { MobileLayout } from './layouts/MobileLayout'

function App() {
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

    const Layout = isMobile ? MobileLayout : DesktopLayout

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <ThemeProvider theme={defaultTheme}>
                <ToastContainer
                    containerId="ROOT_TOAST_CONTAINER"
                    position="bottom-center"
                    autoClose={1000}
                />
                <BrowserRouter>
                    <ScrollToTop />
                    <Layout>
                        <NavigationController />
                    </Layout>
                </BrowserRouter>
            </ThemeProvider>
        </LocalizationProvider>
    )
}

export default App
